(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('SortingService', [
            '$routeParams',
            SortingService
        ]);

    function SortingService($routeParams) {

        var service = {
            matches: matches,
            getCurrentSort: getCurrentSort,
            set: set,
            getSetDir: getSetDir
        };

        return service;

        function matches(s1, s2) {
            if (!s1 || !s2) return 0;
            if (s1.length != s2.length) return 0;
            var match;
            for (var i = 0; i < s1.length; i++) {
                if (s1[i]['name'] !== s2[i]['name']) return 0;
                var m = (s1[i]['dir'] === s2[i]['dir'] ? 1 : -1);
                if (match === undefined) match = m;
                else if (match != m) return 0;
            }
            return match;
        }

        function getCurrentSort(currRouteParams) {
            function decode(str) {
                if (!str) return undefined;
                var x = str.split('_');
                var len = Math.floor(x.length / 2);
                var s = [];
                for (var i = 0; i < len; i++) {
                    s.push({"name": x[i * 2], "dir": x[i * 2 + 1]});
                }
                return s;
            }

            return decode(currRouteParams['sort']);
        }

        // calculates the character representation of the passed sort argument,
        // or returns the currently set URL sort parameter if no argument is specified
        function set(s, currRouteParams) {
            function reverse(s) {
                if (!s.length) s = [s];
                else s = s.slice(0);
                for (var i in s) if (s.hasOwnProperty(i)) {
                    if (s[i]['dir'] === 'd') s[i]['dir'] = 'a';
                    else s[i]['dir'] = 'd';
                }
                return s;
            }

            function toStr(s) {
                if (!s) return "";
                var str = "";
                for (var i in s) if (s.hasOwnProperty(i)) {
                    if (i > 0) str += "_";
                    str += s[i]['name'] + "_" + s[i]['dir'];
                }
                return str;
            }

            if (!s) {
                if (currRouteParams['sort']) return currRouteParams['sort'];
                else return "";
            }
            else {
                if (!s.length) s = [s];
                var current = service.getCurrentSort(currRouteParams);
                if (service.matches(s, current) !== 0) {
                    s = reverse(current);
                }
                return toStr(s);
            }
        }

        function getSetDir(s, currentSort) {
            if (!s.length) s = [s];
            else s = s.slice(0);

            var match = service.matches(s, currentSort);

            if (match === 0) return 0;

            var sortDir = (s[0].dir === "a") ? 1 : -1;
            return sortDir * match;
        }


    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/SortingService.js